module.exports = __webpack_public_path__ + "img/mic.96ce2935.svg";